AdminParentCtrl.controller('AccountServicesController', function($rootScope,
                                                            $scope,
                                                            $routeParams,
                                                            $location,
                                                            $localStorage,
                                                            $sessionStorage,
                                                            $window,
                                                            $compile,
                                                            Validate,
                                                            Authentication,
                                                            Application,
                                                            RouteFilter,
                                                            DEX,
                                                            CiviExchange,
                                                            LoadLocalData,
                                                            InputValidation){
    if(!$scope.isAdmin()){
        $location.path('/admin/accounts/'+ $routeParams.organisationID +'/users');
    }
    
    $scope.page = {};
    $scope.page.header = {};
    $scope.page.sidebar = {};
    $scope.page.header.variant = 'organisationAdmin';
    $scope.page.header.breadcrumbs = 'Organisation Administration';
    $scope.page.header.title = '';
    $scope.page.header.backLink = '#!/admin/accounts';
    $scope.page.sidebar.variant = 'organisationAdmin';
    $scope.page.sidebar.selectedNav = 'Services';
    
    $scope.organisationID = $routeParams.organisationID;
    
    $scope.selectedService = null;
    $scope.selectedOutlet = null;
    
    $scope.availableServices = {
        selected: null,
        availableCount: 0,
        availableOptions: [
            {
                id: 1,
                name: 'Department of Social Services',
                available: true,
                /*outlets: {
                    selected: null,
                    availableCount: 0,
                    names: [
                        {
                            available: true,
                            name: 'Home Modifications'
                        },
                        {
                            available: true,
                            name: 'Home Maintenance'
                        },
                        {
                            available: true,
                            name: 'Allied Health and Therapy Services'
                        }
                    ]
                }*/
            }
        ],
    };
    
    var setAvailableServices = function(){
        var serviceLogins = $rootScope.currentOrganisation.service_logins;
        $scope.availableServices.selected = null;
        $scope.availableServices.availableCount = $scope.availableServices.availableOptions.length;
        
        for(var i = 0; i < $scope.availableServices.availableOptions.length; i++){
            var availableServices = $scope.availableServices.availableOptions[i];

            if(Validate.data.isSet(serviceLogins) && 
               Validate.data.isSet(serviceLogins[availableServices.id]) && 
               Validate.data.isSet(serviceLogins[availableServices.id].active) && serviceLogins[availableServices.id].active === 1){
                availableServices.available = false;
                $scope.availableServices.availableCount--;
            }else{
                availableServices.available = true;
            }
        }
    };
    
    var resetAvailableOutlets = function(){
        $scope.availableServices.availableOptions[0].outlets.selected = null;
        $scope.availableServices.availableOptions[0].outlets.availableCount = $scope.availableServices.availableOptions[0].outlets.names.length;
        for(var i = 0; i < $scope.availableServices.availableOptions[0].outlets.names.length; i++){
            $scope.availableServices.availableOptions[0].outlets.names[i].available = true;
        }
    };
    
    var setAvailableOutlets = function(){
        var outlets = null;
        if($rootScope.currentOrganisation.outlets !== null && 
           Validate.data.isSet($rootScope.currentOrganisation.outlets) &&
           Validate.data.isSet($rootScope.currentOrganisation.outlets[1])){
            outlets = $rootScope.currentOrganisation.outlets[1];
        }
        
        resetAvailableOutlets();
        
        for(var i = 0; i < $scope.availableServices.availableOptions[0].outlets.names.length; i++){
            var availableOutlet = $scope.availableServices.availableOptions[0].outlets.names[i];

            if(outlets !== null){
                for(var j = 0; j < outlets.length; j++){
                    if(outlets[j].name === availableOutlet.name){
                        availableOutlet.available = false;
                        $scope.availableServices.availableOptions[0].outlets.availableCount--;
                    }
                }
            }
        }
    };
    
    $scope.setCurrentOrganisation = function(id, update){
        LoadLocalData.get.organisations('', update).then(function(organisations){
            $rootScope.currentOrganisation = CiviExchange.get.organisation(id);
            processRules();
            $scope.page.header.title = $rootScope.currentOrganisation.name;
            setAvailableServices();
            //setAvailableOutlets();
        }, function(error){
            $scope.referenceData = error;
        });
    };
    
    var processRules = function(){
        if(Validate.data.isSet($rootScope.currentOrganisation.outlets) && Validate.data.isSet($rootScope.currentOrganisation.outlets[1])){
            for(var i = 0; i < $rootScope.currentOrganisation.outlets[1].length; i++){
                if(Validate.data.isSet($rootScope.currentOrganisation.outlets[1][i].outletRules)){
                    var outletRules = $rootScope.currentOrganisation.outlets[1][i].outletRules;
                    for(var j = 0; j < outletRules.length; j++){
                        try{
                            $rootScope.currentOrganisation.outlets[1][i].outletRules[j].rule = JSON.parse($rootScope.currentOrganisation.outlets[1][i].outletRules[j].rule);
                        }catch(e){}
                    }
                }
            }
        }
    };
    
    var initOrganisations = function(){
        $scope.organisations = {
            code: '',
            availableOrganisations: [],
        };
        
        $scope.setCurrentOrganisation($scope.organisationID, false);
    };
    
    var validateOrganisation = {
        update: false,
        $organisationForm: null,
        $organisationName: null,
        $serviceName: null,
        $username: null,
        $password: null,
        $password2: null,
        $outletName: null,
        $outletID: null,
        init: function($elem){
            this.$organisationForm = $elem;
            this.$organisationName = this.$organisationForm.find('#name .form__input');
            this.$serviceName = this.$organisationForm.find('#serviceName .form__input');
            this.$username = this.$organisationForm.find('#serviceUsername .form__input');
            this.$password = this.$organisationForm.find('#servicePassword .form__input');
            this.$password2 = this.$organisationForm.find('#servicePassword2 .form__input');
            this.$outletName = this.$organisationForm.find('#outletName .form__input');
            this.$outletID = this.$organisationForm.find('#outletID .form__input');
        },
        clearInputs: function(){
            this.$organisationName.val('');
            $scope.availableServices.selected = null;
            this.$username.val('');
            this.$password.val('');
            this.$password2.val('');
            this.$homeModID.val('');
            this.$homeMainID.val('');
            this.$alliedHealthID.val('');
            this.$outletID.val('');
            this.$civiURL.val('');
        },
        id: function(id){
            if(InputValidation.length(id)){
                if(InputValidation.isMaxLength(id, 10)){
                    return true;
                }
            }
            return false;
        },
        name: function(){
            var organisationName = this.$organisationName.val();
            if(InputValidation.length(organisationName, this.$organisationName, 'Please enter a Name')){
                if(InputValidation.isMaxLength(organisationName, 255, this.$organisationName, 'Too long')){
                    var currentOrg;
                    if(this.update){
                        currentOrg = $scope.currentOrganisation;
                    }
                    if(InputValidation.organisationNameExists(organisationName, this.$organisationName, 'Name already exists', currentOrg)){
                        return true;
                    }
                }
            }
            return false;
        },
        serviceName: function(serviceName){
            if(InputValidation.length(serviceName, this.$serviceName, 'Please select a value')){
                if(InputValidation.isMaxLength(serviceName, 10, this.$serviceName, 'Something is wrong')){
                    return true;
                }
            }
            return false;
        },
        usernameLength: function(){
            var username = this.$username.val();
            if(InputValidation.length(username)){
                return true;
            }
            return false;
        },
        username: function(currentOrg){
            var username = this.$username.val();
            if(InputValidation.length(username, this.$username, 'Please enter a username')){
                if(InputValidation.isMaxLength(username, 255, this.$username, 'Too long')){
                    
                    if(typeof currentOrg !== 'string'){
                        currentOrg = '';
                    }
                    
                    if(!InputValidation.dssUsernameExists(username, this.$username, 'Username already exists', currentOrg)){
                        return true;
                    }
                }
            }
            return false;
        },
        passwordLength: function(){
            var password = this.$password.val();
            var password2 = this.$password2.val();
            if(InputValidation.length(password) || InputValidation.length(password2)){
                return true;
            }
            return false;
        },
        password1: function(){
            var username = this.$username.val();
            var password = this.$password.val();
            var password2 = this.$password2.val();
            if(InputValidation.length(password, this.$password, 'Please enter a Password')){
                InputValidation.length(username, this.$username, 'Username required');
                if(InputValidation.isMaxLength(password, 255, this.$password, 'Too long')){
                    if(InputValidation.length(password2, this.$password2)){
                        if(InputValidation.equality(password, password2, this.$password, this.$password2, 'Passwords don\'t match')){
                            return true;
                        }
                    }
                }
            }
            return false;
        },
        password2: function(){
            var username = this.$username.val();
            var password = this.$password.val();
            var password2 = this.$password2.val();
            InputValidation.length(password, this.$password, 'Please enter a Password');
            if(InputValidation.length(password2, this.$password2, 'Please re-type your Password')){
                InputValidation.length(username, this.$username, 'Username required');
                if(InputValidation.isMaxLength(password2, 255, this.$password2, 'Too long')){
                    if(InputValidation.equality(password, password2, this.password, this.$password2, 'Passwords don\'t match')){
                        return true;
                    }
                }
            }
            return false;
        },
        outletID: function(outletID){
            if(InputValidation.length(outletID, this.$outletID, 'Please enter an ID')){
                if(InputValidation.isMaxLength(outletID, 20, this.$outletID, 'Too long')){
                    return true;
                }
            }
            return false;
        },
        outletName: function(name){
            if(InputValidation.length(name, this.$outletName, 'Please enter a name')){
                return true;
            }
            return false;
        },
        outletServiceTypeID: function($elem, outletServiceTypeID){
            if(InputValidation.length(outletServiceTypeID, $elem, 'Please enter an ID')){
                if(InputValidation.isMaxLength(outletServiceTypeID, 20, $elem, 'Too long')){
                    return true;
                }
            }
            return false;
        },
        outletCaseID: function($elem, outletCaseID){
            if(InputValidation.length(outletCaseID, $elem, 'Please enter an ID')){
                if(InputValidation.isMaxLength(outletCaseID, 20, $elem, 'Too long')){
                    return true;
                }
            }
            return false;
        }
    };
    
    $scope.rules = {
        requiredData: {
            available: [
                {
                    name: 'Session Time',
                    val: 'SessionTime'
                },
                {
                    name: 'Maintenance Hours',
                    val: 'MaintenanceHours'
                },
                {
                    name: 'Total Cost',
                    val: 'TotalCost'
                }
            ]
        },
        removalData: {
            available: [
                {
                    name: 'Quantity',
                    val: 'Quantity'
                }
            ]
        }
    };
    
    $scope.ruleForm = {
        global: {
            render: function(elemLoc, html){
                if(!document.querySelectorAll(elemLoc)){
                    console.error('Holding element not found');
                    return false;
                }

                html = $compile(html)($scope);
                var $holdingElem = $(elemLoc);
                $holdingElem.append(html);
            }
        },
        getHtml: function(outletID){
            return '<div class="outlet-rules__row outlet-rules--form"> <ul> <li class="row service-convert"> <p class="row__title">Convert Service Type ID</p><div class="fields"> <div class="fields__field"> <div class="row__input-wrap"> <input class="row__input id-input orig-service-id" name="orig-service-id" type="text"/> </div><div class="row__seperator">to</div><div class="row row--input-wrap"> <input class="row__input id-input new-service-id" name="new-service-id" type="text"/> </div></div></div><div class="row__btn-wrap"> <div class="row__btn add-service-id icon glyphicon-plus" ng-click="ruleForm.serviceIDConversionField.add('+ outletID +');"></div></div></li><li class="row case-id-data"> <p class="row__title">Case Type ID</p><div class="fields"> <div class="fields__field"> <div class="row__input-wrap"> <input class="row__input id-input case-id" name="case-id" type="text"/> </div></div></div><div class="row__btn-wrap"> <div class="row__btn add-service-id icon glyphicon-plus" ng-click="ruleForm.caseIDField.add('+ outletID +');"></div></div></li><li class="row require-data"> <p class="row__title">Required</p><div class="fields"> <div class="fields__field"> <div class="row__select-wrap"> <select class="row__select" name="required-data"> <option value="None">None</option> <option ng-repeat="rule in rules.requiredData.available" value="{{rule.val}}">{{rule.name}}</option> </select> </div></div></div><div class="row__btn-wrap"> <div class="row__btn add-service-id icon glyphicon-plus" ng-click="ruleForm.requireDataField.add('+ outletID +');"></div></div></li><li class="row remove-data"> <p class="row__title">Remove</p><div class="fields"> <div class="fields__field"> <div class="row__select-wrap"> <select class="row__select" name="remove-data"> <option value="None">None</option> <option ng-repeat="rule in rules.removalData.available" value="{{rule.val}}">{{rule.name}}</option> </select> </div></div></div><div class="row__btn-wrap"> <div class="row__btn add-service-id icon glyphicon-plus" ng-click="ruleForm.removeDataField.add('+ outletID +');"></div></div></li></ul> <div class="outlet-rules__btn-wrap"> <div class="outlet-rules__btn add-service-id" ng-click="ruleForm.createRule('+ outletID +');">Add Rule</div></div></div>';
        },
        add: function(outletID){
            var holdingElemLoc = 'div[data-outlet-id="'+ outletID +'"] .outlet-rules';
            this.delete(outletID);
            $scope.ruleForm.global.render(holdingElemLoc, this.getHtml(outletID));
        },
        delete: function(outletID){
            var holdingElemLoc = 'div[data-outlet-id="'+ outletID +'"] .outlet-rules .outlet-rules--form';

            $(holdingElemLoc).remove();
        },
        serviceIDConversionField: {
            html: '<div class="fields__field"> <div class="row__input-wrap"> <input class="row__input id-input orig-service-id" name="orig-service-id" type="text"/> </div><div class="row__seperator">to</div><div class="row row--input-wrap"> <input class="row__input id-input new-service-id" name="new-service-id" type="text"/> </div></div>',
            add: function(outletID){
                console.log('HELLLO', outletID);
                var holdingElemLoc = 'div[data-outlet-id="'+ outletID +'"] .outlet-rules--form .service-convert .fields';
                
                $scope.ruleForm.global.render(holdingElemLoc, this.html);
            }
        },
        caseIDField: {
            html: '<div class="fields__field"> <div class="row__input-wrap"> <input class="row__input id-input case-id" name="case-id" type="text"/> </div></div>',
            add: function(outletID){
                console.log('HELLLO', outletID);
                var holdingElemLoc = 'div[data-outlet-id="'+ outletID +'"] .outlet-rules--form .case-id-data .fields';
                
                $scope.ruleForm.global.render(holdingElemLoc, this.html);
            }
        },
        requireDataField: {
            html: '<div class="fields__field"> <div class="row__select-wrap"> <select class="row__select" name="required-data"> <option value="None">None</option> <option ng-repeat="rule in rules.requiredData.available" value="{{rule.val}}">{{rule.name}}</option> </select> </div></div>',
            add: function(outletID){
                var holdingElemLoc = 'div[data-outlet-id="'+ outletID +'"] .outlet-rules--form .require-data .fields';
                
                $scope.ruleForm.global.render(holdingElemLoc, this.html);
            }
        },
        removeDataField: {
            html: '<div class="fields__field"> <div class="row__select-wrap"> <select class="row__select" name="remove-data"> <option value="None">None</option> <option ng-repeat="rule in rules.removalData.available" value="{{rule.val}}">{{rule.name}}</option> </select> </div></div>',
            add: function(outletID){
                var holdingElemLoc = 'div[data-outlet-id="'+ outletID +'"] .outlet-rules--form .remove-data .fields';
                
                $scope.ruleForm.global.render(holdingElemLoc, this.html);
            }
        },
        createRule: function(outletID){
            var holdingElemLoc = 'div[data-outlet-id="'+ outletID +'"] .outlet-rules .outlet-rules--form';
            
            if(!document.querySelectorAll(holdingElemLoc)){
                console.error('Outlet ID element not found', outletID);
                return false;
            }

            var $serviceTypeForm = $(holdingElemLoc);
            var $origIDInput = $serviceTypeForm.find('.service-convert input[name="orig-service-id"]');
            var $newIDInput = $serviceTypeForm.find('.service-convert input[name="new-service-id"]');
            
            var $caseIDData = $serviceTypeForm.find('.case-id-data input[name="case-id"]');
            
            var $requiredData = $serviceTypeForm.find('.require-data select[name="required-data"]');
            
            var $removeData = $serviceTypeForm.find('.remove-data select[name="remove-data"]');

            var valid = true;
            var data = {
                rules: {
                    convert: [],
                    caseId: [],
                    required: [],
                    removal: []
                }
            };
            
            var origIDs = [];
            $origIDInput.each(function(){
                if(!validateOrganisation.outletServiceTypeID($(this), $(this).val())){
                    origIDs.push('None');
                }else{
                    origIDs.push($(this).val());
                }
            });
            
            var newIDs = [];
            $newIDInput.each(function(){
                if(!validateOrganisation.outletServiceTypeID($(this), $(this).val())){
                    newIDs.push('None');
                }else{
                    newIDs.push($(this).val());
                }
            });
            
            for(var i = 0; i < origIDs.length; i++){
                if(origIDs[i] !== 'None' && newIDs[i] !== 'None'){
                    var conversionObject = {
                        orig: origIDs[i],
                        new: newIDs[i]
                    };

                    data.rules.convert.push(conversionObject);
                }
            }
            
            $caseIDData.each(function(){
                if(validateOrganisation.outletCaseID($(this), $(this).val())){
                    data.rules.caseId.push($(this).val());
                }
            });
            
            $requiredData.each(function(){
                if($(this).val() !== 'None'){
                    data.rules.required.push($(this).val());
                }
            });
            
            $removeData.each(function(){
                if($(this).val() !== 'None'){
                    data.rules.removal.push($(this).val());
                }
            });

            if(!valid){
                console.error('Incorrect values found in form data');
                return false;
            }

            data.organisation_id = $scope.organisationID;
            data.outlet_id = outletID;
            console.log('ADD RULE', data);
            CiviExchange.create.outletRule(data).then(function(){
                console.info('Successfully added outlet rule');
                $scope.setCurrentOrganisation($scope.organisationID, true);
            }, function(errorData){
                console.error('Issue adding outlet rule', errorData);
            });
        },
        deleteRule: function(outletID, ruleID){
            var data = {};
            
            data.organisation_id = $scope.organisationID;
            data.outlet_id = outletID;
            data.rule_id = ruleID;

            CiviExchange.delete.outletRule(data).then(function(){
                console.info('Successfully deleted outlet rule');
                $scope.setCurrentOrganisation($scope.organisationID, true);
            }, function(errorData){
                console.error('Issue deleteing outlet rule', errorData);
            });
        }
    };
    
    $scope.setupAddService = function(id){
        var $form = $('#modal-form');
        var $feedback = $form.find('#feedback');
        validateOrganisation.init($form);
        validateOrganisation.update = false;

        validateOrganisation.$serviceName.on('change', function(){
            validateOrganisation.serviceName($scope.availableServices.selected);
        });

        validateOrganisation.$username.on('input', function(){
            validateOrganisation.username();
        });

        validateOrganisation.$password.on('input', function(){
            validateOrganisation.password1();
        });

        validateOrganisation.$password2.on('input', function(){
            validateOrganisation.password2();
        });

        $form.find("#submit-button").click(function(event){
            event.preventDefault();
            var cSending = 'form__input--sending';
            var cSent = 'form__input--sent';
            var that = $(this);
            var valid = true;
            var data = {};

            if(!validateOrganisation.id(id)){
               valid = false;
            }

            if(!validateOrganisation.serviceName($scope.availableServices.selected)){
               valid = false;
            }

            if(!validateOrganisation.username()){
               valid = false;
            }

            if(!validateOrganisation.password1()){
               valid = false;
            }

            if(!validateOrganisation.password2()){
               valid = false;
            }

            if(!valid){
                console.error('Incorrect values found in form data');
                return false;
            }
            
            data.organisation_id = id;
            data.service_id = $scope.availableServices.selected;
            data.username = validateOrganisation.$username.val();
            data.password = validateOrganisation.$password.val();

            DEX.validate.user({dssUsername: data.username, dssPassword: data.password}).then(function(feedback){
                CiviExchange.create.service(data).then(function(){
                    console.info('Successfully added service');
                    //validateOrganisation.clearInputs();
                    $scope.setCurrentOrganisation($scope.organisationID, true);
                    setAvailableServices();
                    $scope.modal.close();
                }, function(errorData){
                    console.error('Issue creating service', errorData);
                    $feedback.html('<p class="error">'+ errorData +'</p>');
                });
            }, function(errorData){
                console.error('Issue verifying DEX user login details', errorData);
                $feedback.html('<p class="error">Issue verifying DEX user login details</p>');
            });
        });
    };
    
    $scope.setupUpdateService = function(id, serviceID){
        var $form = $('#modal-form');
        var $feedback = $form.find('#feedback');
        validateOrganisation.init($form);
        validateOrganisation.update = true;
        
        validateOrganisation.$username.on('input', function(){
            validateOrganisation.username();
        });

        validateOrganisation.$password.on('input', function(){
            validateOrganisation.password1();
        });

        validateOrganisation.$password2.on('input', function(){
            validateOrganisation.password2();
        });

        $form.find("#submit-button").click(function(event){
            event.preventDefault();
            var cSending = 'form__input--sending';
            var cSent = 'form__input--sent';
            var that = $(this);
            var valid = true;
            var data = {};
            
            if(!validateOrganisation.id(id)){
               valid = false;
            }
            
            if(!validateOrganisation.serviceName(serviceID)){
               valid = false;
            }
            
            if(!validateOrganisation.username()){
               valid = false;
            }

            if(!validateOrganisation.password1()){
               valid = false;
            }

            if(!validateOrganisation.password2()){
               valid = false;
            }
            
            if(!valid){
                console.error('Incorrect values found in form data');
                return false;
            }
            
            data.organisation_id = id;
            data.service_id = serviceID;
            data.username = validateOrganisation.$username.val();
            data.password = validateOrganisation.$password.val();
            
            DEX.validate.user({dssUsername: data.username, dssPassword: data.password}).then(function(feedback){
                CiviExchange.update.service(data).then(function(){
                    console.info('Successfully updated service');
                    //validateOrganisation.clearInputs();
                    $scope.setCurrentOrganisation($scope.organisationID, true);
                    //setAvailableOutlets();
                    $scope.modal.close();
                }, function(errorData){
                    console.error('Issue updating service', errorData);
                    $feedback.html('<p class="error">'+ errorData +'</p>');
                });
            }, function(errorData){
                console.error('Issue verifying DEX user login details', errorData);
                $feedback.html('<p class="error">Issue verifying DEX user login details</p>');
            });
        });
    };
    
    $scope.deleteService = function(organisationID, serviceID){
        var $form = $('#modal-form');
        var $feedback = $form.find('#feedback');
        var valid = true;
        var data = {};

        if(!validateOrganisation.id(organisationID)){
           valid = false;
        }

        if(!validateOrganisation.serviceName(serviceID)){
           valid = false;
        }
        
        if(!valid){
            console.error('Incorrect values found in form data');
            return false;
        }
        
        data.organisation_id = organisationID;
        data.service_id = serviceID;
        
        $scope.deleteServiceSubmit = {};
        $scope.deleteServiceSubmit.allow = false;
        $scope.deleteServiceSubmit.submit = function(){
            if(!$scope.deleteServiceSubmit.allow){
                $scope.modal.notification('deleteService');
                return false;
            }
            
            CiviExchange.delete.service(data).then(function(){
                console.info('Successfully deleted service');
                //validateOrganisation.clearInputs();
                $scope.setCurrentOrganisation($scope.organisationID, true);
                //setAvailableOutlets();
                $scope.modal.close();
            }, function(errorData){
                console.error('Issue deleting service', errorData);
                $feedback.html('<p class="error">Issue deleting service</p>');
            });
        };
        
        $scope.deleteServiceSubmit.submit();
    };
    
    $scope.deleteCurrentService = function(){
        $scope.deleteServiceSubmit.allow = true;
        $scope.modal.notification('');
        $scope.deleteServiceSubmit.submit();
    };
    
    $scope.setupAddOutlet = function(orgID, serviceID){
        var $form = $('#modal-form');
        var $feedback = $form.find('#feedback');
        validateOrganisation.init($form);
        validateOrganisation.update = true;

        validateOrganisation.$outletName.on('input', function(){
            validateOrganisation.outletName(validateOrganisation.$outletName.val());
        });
        
        validateOrganisation.$outletID.on('input', function(){
            validateOrganisation.outletID(validateOrganisation.$outletID.val());
        });

        $form.find("#submit-button").click(function(event){
            event.preventDefault();
            var cSending = 'form__input--sending';
            var cSent = 'form__input--sent';
            var that = $(this);
            var valid = true;
            var data = {};
            
            if(!validateOrganisation.id(orgID)){
               valid = false;
            }
            
            if(!validateOrganisation.serviceName(serviceID)){
               valid = false;
            }
            
            if(!validateOrganisation.outletName(validateOrganisation.$outletName.val())){
               valid = false;
            }
            
            if(!validateOrganisation.outletID(validateOrganisation.$outletID.val())){
               valid = false;
            }
            
            if(!valid){
                console.error('Incorrect values found in form data');
                return false;
            }
            
            data.organisation_id = orgID;
            data.service_id = serviceID;
            data.outlet_name = validateOrganisation.$outletName.val();
            data.outlet_id = validateOrganisation.$outletID.val();
            
            CiviExchange.create.outlet(data).then(function(){
                console.info('Successfully added outlet');
                //validateOrganisation.clearInputs();
                $scope.setCurrentOrganisation($scope.organisationID, true);
                //setAvailableOutlets();
                $scope.modal.close();
            }, function(errorData){
                console.error('Issue adding outlet', errorData);
                $feedback.html('<p class="error">Issue adding outlet</p>');
            });
        });
    };
    
    $scope.setupUpdateOutlet = function(orgID, serviceID, outletID){
        var $form = $('#modal-form');
        var $feedback = $form.find('#feedback');
        validateOrganisation.init($form);
        validateOrganisation.update = true;

        validateOrganisation.$outletName.on('input', function(){
            validateOrganisation.outletName(validateOrganisation.$outletName.val());
        });
        
        validateOrganisation.$outletID.on('input', function(){
            validateOrganisation.outletID(validateOrganisation.$outletID.val());
        });

        $form.find("#submit-button").click(function(event){
            event.preventDefault();
            var cSending = 'form__input--sending';
            var cSent = 'form__input--sent';
            var that = $(this);
            var valid = true;
            var data = {};
            
            if(!validateOrganisation.id(orgID)){
               valid = false;
            }
            
            if(!validateOrganisation.serviceName(serviceID)){
               valid = false;
            }
            
            if(!validateOrganisation.outletName(validateOrganisation.$outletName.val())){
               valid = false;
            }
            
            if(!validateOrganisation.outletID(validateOrganisation.$outletID.val())){
               valid = false;
            }
            
            if(!valid){
                console.error('Incorrect values found in form data');
                return false;
            }
            
            data.organisation_id = orgID;
            data.service_id = serviceID;
            data.id = outletID;
            data.outlet_name = validateOrganisation.$outletName.val();
            data.outlet_id = validateOrganisation.$outletID.val();
            console.log('UPDATE', data);
            CiviExchange.update.outlet(data).then(function(){
                console.info('Successfully updated outlet');
                //validateOrganisation.clearInputs();
                $scope.setCurrentOrganisation($scope.organisationID, true);
                //setAvailableOutlets();
                $scope.modal.close();
            }, function(errorData){
                console.error('Issue updating outlet', errorData);
                $feedback.html('<p class="error">Issue updating outlet</p>');
            });
        });
    };
    
    $scope.deleteOutlet = function(organisationID, serviceID, outletID){
        var $form = $('#modal-form');
        var $feedback = $form.find('#feedback');
        var valid = true;
        var data = {};

        if(!validateOrganisation.id(organisationID)){
           valid = false;
        }

        if(!validateOrganisation.serviceName(serviceID)){
           valid = false;
        }
        
        if(!valid){
            console.error('Incorrect values found in form data');
            return false;
        }
        
        data.organisation_id = organisationID;
        data.service_id = serviceID;
        data.id = outletID;
        
        $scope.deleteOutletSubmit = {};
        $scope.deleteOutletSubmit.allow = false;
        $scope.deleteOutletSubmit.submit = function(){
            if(!$scope.deleteOutletSubmit.allow){
                $scope.modal.notification('deleteOutlet');
                return false;
            }
            
            CiviExchange.delete.outlet(data).then(function(){
                console.info('Successfully deleted outlet');
                //validateOrganisation.clearInputs();
                $scope.setCurrentOrganisation($scope.organisationID, true);
                //setAvailableOutlets();
                $scope.modal.close();
            }, function(errorData){
                console.error('Issue deleted outlet', errorData);
                $feedback.html('<p class="error">Issue deleted outlet</p>');
            });
        };
        
        $scope.deleteOutletSubmit.submit();
    };
    
    $scope.deleteCurrentOutlet = function(){
        $scope.deleteOutletSubmit.allow = true;
        $scope.modal.notification('');
        $scope.deleteOutletSubmit.submit();
    };
    
    $scope.setSelectedService = function(selectedService){
        $scope.selectedService = selectedService;
    };
    
    $scope.setSelectedOutlet = function(id, outletName, outletID){
        $scope.selectedOutlet = {
            id: id,
            name: outletName,
            outlet_id: outletID
        };
    };
    
    $scope.modal = function(url, pagename){
        $scope.modal.properties = {};
        
        $scope.modal.open = function(url){
            $scope.modal.properties.url = url;
            var html = '<div ng-include="\''+ url +'\'" ng-click="modal.close()" id="modal-blanket" class="modal-blanket"></div>';
            var temp = $compile(html)($scope);
            angular.element(document.getElementById('inner-content')).append('<div id="modal-container"></div>');
            angular.element(document.getElementById('modal-container')).html(temp);
        };
    
        $scope.modal.loadPage = function(pageName){
            $scope.modal.properties.pageName = pageName;
            $scope.modal.open($scope.modal.properties.url);
        };

        $scope.modal.close = function(){
            $scope.modal.properties = {};
            angular.element(document.getElementById('modal-container')).remove();
        };

        $scope.modal.notification = function(notificationName){
            $scope.modal.properties.notificationName = notificationName;
            $scope.modal.open($scope.modal.properties.url);
        };
        
        if(typeof url === 'string'){
            $scope.modal.properties.url = url;
            if(typeof pagename === 'string'){
                $scope.modal.loadPage(pagename);
            }else{
                $scope.modal.open(url);
            }
        }
    };
    
    if($rootScope.canAccess('/admin') && Authentication.isAdmin()){
        initOrganisations();
    }else if($rootScope.canAccess('/admin') && Authentication.isOrganisationAdmin()){
        initOrganisations();
    }
});